import React, { useCallback, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Image, View } from 'react-native';
import { useFocusEffect } from '@react-navigation/native';
import { TWCBackHandler, TWCPage, TWCText } from '@components';

import { assets } from '@assets';
import { onboardingTestIDs, Theme } from '@constants';
import { navigationService } from '@services';

import { styles } from './styles';

const tPath = 'successPage.';

export const SuccessPage = () => {
  const { t } = useTranslation();

  useEffect(() => {
    const timeout = setTimeout(() => {
      navigationService.replace('MainMenu');
    }, 2000);

    return () => clearTimeout(timeout);
  }, []);

  // Prevents user from backing out of the success screen
  useFocusEffect(
    useCallback(() => {
      const onBackPress = () => true;

      TWCBackHandler.addEventListener('hardwareBackPress', onBackPress);

      return () => TWCBackHandler.removeEventListener('hardwareBackPress', onBackPress);
    }, []),
  );

  return (
    <TWCPage childIds={[]} pageID={onboardingTestIDs.pages.successPage}>
      <View style={styles.panel}>
        <View style={Theme.styles.center}>
          <Image source={assets.successCheckmark} style={styles.successCheckmark} />
          <TWCText
            style={styles.successText}
            testID={onboardingTestIDs.successPage.successPageText}
            variant={'regularText36'}
          >
            {t(`${tPath}success`)}
          </TWCText>
        </View>
      </View>
    </TWCPage>
  );
};
